export const getNudgeCard = async ({ page }) => {
  if (!page) return;
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_API_URL}/items/nudge_card?filter={"page":{"_eq":"${page}"}}`,
      {
        cache: 'no-cache',
      }
    );

    if (response.ok) {
      const data = await response.json();
      return data.data[0];
    }
    return null;
  } catch (error) {
    console.log(error);
  }
};
